import { Directive, ElementRef, HostListener, input } from '@angular/core';

@Directive({
  selector: 'img[withFallbackImage]',
})
export class WithFallbackImageDirective {
  fallbackImage = input('assets/fallback-image.png');

  constructor(private readonly elementRef: ElementRef<HTMLImageElement>) {}

  @HostListener('error')
  loadFallbackOnError() {
    const element = this.elementRef.nativeElement;
    element.src = this.fallbackImage();
  }
}
